import { DataTable, DataTableResource, DataTableTranslations } from 'angular7-data-table';
import { NgbModalRef, NgbModalOptions, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, TemplateRef, ViewChild, Input } from '@angular/core';
import { CdkDragDrop, moveItemInArray, CdkDragExit } from '@angular/cdk/drag-drop';
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CommonService } from "../../../common/common.service";
import { NgxSpinnerService } from "ngx-spinner";
import { CourseManagementService } from "../course-management.service";
import { HttpResponse } from "@angular/common/http";
import Swal from "sweetalert2";


@Component({
  selector: 'app-add-asr',
  templateUrl: './add-asr.component.html',
  styleUrls: ['./add-asr.component.css']
})
export class AddAsrComponent implements OnInit {
  @Input() disabled = false;

  @ViewChild(TemplateRef, { static: false }) tpl: TemplateRef<any>;

  AsrForm: FormGroup;
  slideForm: FormGroup;
  optionForm: FormGroup;

  formSubmitted: boolean = false;
  showLessonError: boolean = true;
  showWeekError: boolean = true;
  showAdditionalError: boolean = true;
  isDisabled: boolean = true;

  //QUESTION TYPE BOOLEAN
  show_optionsButton: boolean = false;
  show_optionsCheckBox: boolean = false;
  show_optionsSlider: boolean = false;
  show_slider: boolean = false;
  show_text: boolean = false;
  show_days: boolean = false;
  show_textDropdown: boolean = false;
  showOptionError: boolean = true;
  question_select_ph: boolean = true;
  question_select_nu: boolean = true;
  question_select_next: boolean = true;
  question_select_in: boolean = true;


  user_question_type: String;
  question_type: any;
  selectedFile: any;
  uploadcourseImage: any;
  week: string;
  courseId: string;
  lessonId: string;
  ASRReq = {
    courseId: null,
    lessonId: null,
    week: null,
    observeAudioUrl: null,
    physicalQuestion: [],
    nutritionalQuestion: [],
    introspectQuestion: [],
    nextActionStepQuestion: []
  }
  ASRQuestionType: string;
  optionList: any;
  QuestionFormReq = {
    questionText: null,
    iconName: null,
    type: null,
    options: [],
    daysSuccess: [],
    sliderDetails: {
      minValue: 0,
      maxValue: 0,
      defaultValue: 0,
      multiplyFactor: 0
    },
    sortOrder: null,
    weightage: null,
    evaluationData: "NA"

  }
  uploadCourseImage: any;
  BuildingQuestionTypeList = [
    { value: 'days', viewValue: 'Days' },
    { value: 'optionsButton', viewValue: 'Option' },
    { value: 'optionsCheckBox', viewValue: 'Check Box' },
    { value: 'slider', viewValue: 'slider' },
  ];
  ActionStepQuestionTypeList = [
    { value: 'days', viewValue: 'Days' },
    { value: 'optionsButton', viewValue: 'Option' },
    { value: 'optionsCheckBox', viewValue: 'Check Box' },
    { value: 'slider', viewValue: 'slider' },
    { value: 'text', viewValue: 'text' },
    { value: 'textDropdown', viewValue: 'Text Drop Down' },
    { value: 'optionsSlider', viewValue: 'Options Slider' },
    { value: 'multiOptionsCheckBox', viewValue: 'Multi Options CheckBox' },

  ];

  IconList = [
    { value: 'noIcon', viewValue: 'noIcon' },
    { value: 'fasting', viewValue: 'fasting' },
    { value: 'sleep', viewValue: 'sleep' },
    { value: 'water', viewValue: 'water' },
    { value: 'exercise', viewValue: 'exercise' },
    { value: 'nutrition', viewValue: 'nutrition' },
    { value: 'introspect', viewValue: 'introspect' },
  ];




  private modalRef: NgbModalRef;

  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false,
    size:"lg"
  };

  DaysList = [{ day: "1", value: "0", evaluationData: "NA" }, { day: "2", value: "0", evaluationData: "NA" }, { day: "3", value: "0", evaluationData: "NA" }, { day: "4", value: "0", evaluationData: "NA" }, { day: "5", value: "0", evaluationData: "NA" }, { day: "6", value: "0", evaluationData: "NA" }, { day: "7", value: "0", evaluationData: "NA" }];

  closeResult: string;
  statusFormSubmitted: boolean = false;
  statusForm: FormGroup;
  optionListtemp = [];
  finalFeatureList = [];
  temp: any;
  feature: string;
  day_number_error: String;
  number_validation: string;
  show_number_validation: boolean = false;
  validateQuestion: boolean = false;
  show_min_error: String = 'false';
  show_max_error: String = 'false';

  asrDetail: any;
  editQuestionIndex: number;
  editquestionType: String;
  editQuestionflag: boolean = false;
  isNewAction:boolean = false;

  constructor(private formBuilder: FormBuilder, private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private commonService: CommonService,
    private CourseManagementService: CourseManagementService) { }

  ngOnInit() {
    this.ASRQuestionType = "PHYSICAL";
    this.courseId = this.route.snapshot.params["course_Id"];
    this.route.queryParams.subscribe(param => {
      this.week = param['week'];
      this.lessonId = param['lesson'];
    });

    this.initialiseForms();

  }

  initialiseForms() {
    this.AsrForm = this.fb.group({
      week: ["", [Validators.required]],
      observeAudioUrl: ["", [Validators.required]],
      questionType: ["", [Validators.required]],
      showQuestionType: ["", [Validators]]
    });
    this.AsrForm.controls['week'].setValue(this.week);
    // this.AsrForm.controls['week'].disable();

    this.slideForm = this.fb.group({
      minValue: [0, [Validators.required]],
      maxValue: [0, [Validators.required]],
      defaultValue: [0, [Validators.required]],
      multiplyFactor: [0, [Validators.required]]
    });
    this.optionForm = this.fb.group({
      label: ["", [Validators.required]],
      value: [0, [Validators.required]],
      evaluationData: ["NA", [Validators]],
      sortOrder: ["", [Validators]],
      isSelected: ["", [Validators]],
      weightage: ["", [Validators.required]],
      iconName: ["c", [Validators.required]],
      questionText: ["", [Validators.required]],
    });

  }





  resetQuestion() {
    this.slideForm = this.fb.group({
      minValue: [0, [Validators.required]],
      maxValue: [0, [Validators.required]],
      defaultValue: [0, [Validators.required]],
      multiplyFactor: [0, [Validators.required]]
    });
    this.optionForm = this.fb.group({
      label: ["", [Validators.required]],
      value: [0, [Validators.required]],
      evaluationData: ["NA", [Validators]],
      sortOrder: ["", [Validators]],
      isSelected: ["", [Validators]],
      weightage: ["", [Validators.required]],
      iconName: ["noIcon", [Validators.required]],
      questionText: ["", [Validators.required]],
    });


    this.QuestionFormReq = {
      questionText: null,
      iconName: null,
      type: null,
      options: [],
      daysSuccess: [],
      sliderDetails: {
        minValue: 0,
        maxValue: 0,
        defaultValue: 0,
        multiplyFactor: 0
      },
      sortOrder: null,
      weightage: null,
      evaluationData: ""

    }

    this.optionForm.reset();
    this.slideForm.reset();
    this.formSubmitted = false;
    this.optionList = [];
    this.DaysList = [{ day: "1", value: "0", evaluationData: "NA" }, { day: "2", value: "0", evaluationData: "NA" }, { day: "3", value: "0", evaluationData: "NA" }, { day: "4", value: "0", evaluationData: "NA" }, { day: "5", value: "0", evaluationData: "NA" }, { day: "6", value: "0", evaluationData: "NA" }, { day: "7", value: "0", evaluationData: "NA" }]
    this.optionForm.controls['evaluationData'].setValue("NA");



  }

  setamount(event, index) {
    this.DaysList[index]['value'] = null;
  }

  setEvaluationData(event, index) {

    this.DaysList[index]['evaluationData'] = null;
  }

  setEvaluation(event, index) {
    this.optionForm.controls['evaluationData'].setValue(null);

  }
  setsliderValue(value) {

    if (value == 'min') {
      this.slideForm.controls['minValue'].setValue(null);
    }
    if (value == 'max') {
      this.slideForm.controls['maxValue'].setValue(null);
    }
    if (value == 'default') {
      this.slideForm.controls['defaultValue'].setValue(null);
    }
    if (value == 'multi') {
      this.slideForm.controls['multiplyFactor'].setValue(null);
    }

  }
  onlyNumberKey(event) {

    return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
  }

  onlyNumber(event) {

    return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
  }


  _keyPress(type) {

    let minValue = this.slideForm.value.minValue;
    let maxValue = this.slideForm.value.maxValue;
    if (type == 'min') {
      if (minValue > maxValue) {
        this.validateQuestion = true;
        this.show_min_error = 'true';
      }
      else if (minValue < maxValue) {
        this.validateQuestion = false;
        this.show_min_error = 'false';
        this.show_max_error = 'false';
      }
    }

    if (type == 'max') {
      if (maxValue > minValue) {
        this.validateQuestion = false;
        this.show_max_error = 'false';
        this.show_min_error = 'false';
      } else if (minValue > maxValue) {
        this.validateQuestion = false;
        this.show_max_error = 'true';
        this.show_min_error = 'false';
      }
    }

  }
  onChange(event, index) {
    if (event > 100) {

      this.show_number_validation = true;
      this.validateQuestion = true
    } else {
      this.show_number_validation = false;
      this.validateQuestion = false;
    }
  }

  deleteQuestion(questionType, index) {

    if (questionType == 'PHYSICAL') {
      this.ASRReq.physicalQuestion.splice(index, 1);
    }
    if (questionType == 'NUTRITIONAL') {
      this.ASRReq.nutritionalQuestion.splice(index, 1);

    }
    if (questionType == 'INTROSPECT') {
      this.ASRReq.introspectQuestion.splice(index, 1);

    }
    if (questionType == 'NEXTACTION') {
      this.ASRReq.nextActionStepQuestion.splice(index, 1);
    }
  }

  editdeleteQuestion(questionType, index) {

    this.editQuestionIndex = index;
    this.editquestionType = questionType;
    this.editQuestionflag = true;
  }


  editQuestion(row) {

    if (row.type == "days") {
      let tempday = [];
      row.daysSuccess.forEach((element, index) => {
        tempday.push({ day: element.day, value: element.value, evaluationData: element.evaluationData });
      });
      this.DaysList = tempday;
      this.optionForm.controls['questionText'].setValue(row.questionText);

    }


    if (row.type == "optionsButton" || row.type == "optionsCheckBox" || row.type == "textDropdown" || row.type == "multiOptionsCheckBox") {
      let optiontemp = [];
      row.options.forEach((element, index) => {
        optiontemp.push({ label: element.label, value: element.value, evaluationData: element.evaluationData });
      });
      this.showOptionError = false;
      this.optionList = optiontemp;
      this.optionListtemp = optiontemp;
      this.optionForm.controls['questionText'].setValue(row.questionText);
    }
    if (row.type == "slider") {

      this.slideForm.controls['minValue'].setValue(row.sliderDetails.minValue);
      this.slideForm.controls['maxValue'].setValue(row.sliderDetails.maxValue);
      this.slideForm.controls['defaultValue'].setValue(row.sliderDetails.defaultValue);
      this.slideForm.controls['multiplyFactor'].setValue(row.sliderDetails.multiplyFactor);
      this.optionForm.controls['questionText'].setValue(row.questionText);

    }

    if (row.type == "optionsSlider") {

      let optiontemp = [];
      row.options.forEach((element, index) => {
        optiontemp.push({ label: element.label, value: element.value, evaluationData: element.evaluationData });
      });
      this.showOptionError = false;
      this.optionList = optiontemp;
      this.optionListtemp = optiontemp;
      this.slideForm.controls['minValue'].setValue(row.sliderDetails.minValue);
      this.slideForm.controls['maxValue'].setValue(row.sliderDetails.maxValue);
      this.slideForm.controls['defaultValue'].setValue(row.sliderDetails.defaultValue);
      this.slideForm.controls['multiplyFactor'].setValue(row.sliderDetails.multiplyFactor);
      this.optionForm.controls['questionText'].setValue(row.questionText);

    }
    if (row.type == "text") {


      this.optionForm.controls['questionText'].setValue(row.questionText);
      this.optionForm.controls['evaluationData'].setValue(row.evaluationData);

    }
  }

  saveQuestion(type: any) {


    this.formSubmitted = true;

    if (type == 'optionsButton' || type == 'optionsCheckBox' || type == 'multiOptionsCheckBox') {
      this.QuestionFormReq.questionText = this.optionForm.value.questionText;
      this.QuestionFormReq.iconName = this.optionForm.value.iconName;
      this.QuestionFormReq.weightage = 0;
      this.QuestionFormReq.type = this.question_type;
      let optionListtemp = [];
      this.optionList.forEach((element, index) => {
        optionListtemp.push({ label: element.label, value: element.value, evaluationData: element.evaluationData, sortOrder: index });
        this.QuestionFormReq.options = optionListtemp;
        this.optionListtemp = [];
      });


    }

    if (type == 'days') {
      this.QuestionFormReq.questionText = this.optionForm.value.questionText;
      this.QuestionFormReq.iconName = this.optionForm.value.iconName;
      this.QuestionFormReq.weightage = this.optionForm.value.weightage;
      this.QuestionFormReq.type = this.question_type;
      this.QuestionFormReq.daysSuccess = this.DaysList;
      this.QuestionFormReq.weightage = 0;

    }
    if (type == 'slider') {

      this.QuestionFormReq.questionText = this.optionForm.value.questionText;
      this.QuestionFormReq.iconName = this.optionForm.value.iconName;
      this.QuestionFormReq.weightage = 0;
      this.QuestionFormReq.type = this.question_type;
      this.QuestionFormReq.sliderDetails.minValue = this.slideForm.value.minValue;
      this.QuestionFormReq.sliderDetails.maxValue = this.slideForm.value.maxValue;
      this.QuestionFormReq.sliderDetails.defaultValue = this.slideForm.value.defaultValue;
      this.QuestionFormReq.sliderDetails.multiplyFactor = this.slideForm.value.multiplyFactor;

    }
    if (type == 'optionsSlider') {

      this.QuestionFormReq.questionText = this.optionForm.value.questionText;
      this.QuestionFormReq.iconName = this.optionForm.value.iconName;
      this.QuestionFormReq.weightage = 0;
      this.QuestionFormReq.type = this.question_type;
      // for the option
      let optionListtemp = [];
      this.optionList.forEach((element, index) => {

        optionListtemp.push({ label: "NA", value: element.value, evaluationData: element.evaluationData, sortOrder: index });
        this.QuestionFormReq.options = optionListtemp;
      });
      this.QuestionFormReq.sliderDetails.minValue = this.slideForm.value.minValue;
      this.QuestionFormReq.sliderDetails.maxValue = this.slideForm.value.maxValue;
      this.QuestionFormReq.sliderDetails.defaultValue = this.slideForm.value.defaultValue;
      this.QuestionFormReq.sliderDetails.multiplyFactor = this.slideForm.value.multiplyFactor;

    }

    if (type == 'text') {

      this.QuestionFormReq.questionText = this.optionForm.value.questionText;
      this.QuestionFormReq.iconName = this.optionForm.value.iconName;
      this.QuestionFormReq.weightage = 0;
      this.QuestionFormReq.type = this.question_type;
      this.QuestionFormReq.evaluationData = this.optionForm.value.evaluationData;
    }
    if (type == 'textDropdown') {

      this.QuestionFormReq.questionText = this.optionForm.value.questionText;
      this.QuestionFormReq.iconName = this.optionForm.value.iconName;
      this.QuestionFormReq.weightage = 0;
      this.QuestionFormReq.type = this.question_type;
      this.QuestionFormReq.evaluationData = this.optionForm.value.evaluationData;
      let optionListtemp = [];
      this.optionList.forEach((element, index) => {
        optionListtemp.push({ label: element.label, value: element.value, evaluationData: element.evaluationData, sortOrder: index });
        this.QuestionFormReq.options = optionListtemp;
      });
    }


    if (this.editQuestionflag == true) {
      this.deleteQuestion(this.editquestionType, this.editQuestionIndex);
    }


    ////////////////////////////////////////////////////////////////////////////////
    //ASR QUESTION TYPE 
    //////////////////////////////////////////////////////////////////////////
    if (this.ASRQuestionType == 'PHYSICAL') {
      this.ASRReq.physicalQuestion.push(this.QuestionFormReq);

    }
    if (this.ASRQuestionType == 'NUTRITIONAL') {
      this.ASRReq.nutritionalQuestion.push(this.QuestionFormReq);

    }
    if (this.ASRQuestionType == 'INTROSPECT') {
      this.ASRReq.introspectQuestion.push(this.QuestionFormReq)

    }
    if (this.ASRQuestionType == 'NEXTACTION') {

      this.ASRReq.nextActionStepQuestion.push(this.QuestionFormReq);

    }

    this.editQuestionflag = false;


    this.QuestionFormReq = {
      questionText: null,
      iconName: null,
      type: null,
      options: [],
      daysSuccess: [],
      sliderDetails: {
        minValue: 0,
        maxValue: 0,
        defaultValue: 0,
        multiplyFactor: 0
      },
      sortOrder: null,
      weightage: null,
      evaluationData: ""

    }

    this.optionForm.reset();
    this.slideForm.reset();

    this.optionForm.controls['evaluationData'].setValue("NA");
    this.optionList = [];
    this.DaysList = [{ day: "1", value: "0", evaluationData: "NA" }, { day: "2", value: "0", evaluationData: "NA" }, { day: "3", value: "0", evaluationData: "NA" }, { day: "4", value: "0", evaluationData: "NA" }, { day: "5", value: "0", evaluationData: "NA" }, { day: "6", value: "0", evaluationData: "NA" }, { day: "7", value: "0", evaluationData: "NA" }];
    this.formSubmitted = false;


  }


  submitASR() {
    let tempphy = [];
    let tempnuti = [];
    let tempindo = [];
    let tempnextaction = [];
    this.formSubmitted = true;
    this.ASRReq.lessonId = this.lessonId;
    this.ASRReq.courseId = this.courseId;
    this.ASRReq.week = this.AsrForm.value.week;
    let aUrl = this.AsrForm.value.observeAudioUrl.trim();
    if (aUrl && !aUrl.startsWith('http://') && !aUrl.startsWith('https://')) {
      aUrl = 'https://' + aUrl;
    }
    this.ASRReq.observeAudioUrl = aUrl;


    this.ASRReq.physicalQuestion.forEach((element, index) => {
      tempphy.push({
        questionText: element.questionText,
        iconName: element.iconName,
        type: element.type,
        options: element.options,
        daysSuccess: element.daysSuccess,
        sliderDetails: element.sliderDetails,
        sortOrder: index,
        weightage: element.weightage,
        evaluationData: element.evaluationData

      });
    });
    this.ASRReq.physicalQuestion = tempphy;

    this.ASRReq.nutritionalQuestion.forEach((element, index) => {
      tempnuti.push({

        questionText: element.questionText,
        iconName: element.iconName,
        type: element.type,
        options: element.options,
        daysSuccess: element.daysSuccess,
        sliderDetails: element.sliderDetails,
        sortOrder: index,
        weightage: element.weightage,
        evaluationData: element.evaluationData

      });
    });
    this.ASRReq.nutritionalQuestion = tempnuti;

    this.ASRReq.introspectQuestion.forEach((element, index) => {
      tempindo.push({

        questionText: element.questionText,
        iconName: element.iconName,
        type: element.type,
        options: element.options,
        daysSuccess: element.daysSuccess,
        sliderDetails: element.sliderDetails,
        sortOrder: index,
        weightage: element.weightage,
        evaluationData: element.evaluationData

      });
    });

    this.ASRReq.introspectQuestion = tempindo;

    this.ASRReq.nextActionStepQuestion.forEach((element, index) => {
      tempnextaction.push({
        questionText: element.questionText,
        iconName: element.iconName,
        type: element.type,
        options: element.options,
        daysSuccess: element.daysSuccess,
        sliderDetails: element.sliderDetails,
        sortOrder: index,
        weightage: element.weightage,
        evaluationData: element.evaluationData

      });
    });
    this.ASRReq.nextActionStepQuestion = tempnextaction;

    console.log(this.ASRReq);

    if (this.AsrForm.valid) {
      this.CourseManagementService.saveASR(this.ASRReq).subscribe(data => {
        if (data["message"] == "Success") {
          Swal.fire("Success", "ASR Updated Successfully!", "success");
          this.router.navigate(['main/course-management/view-lesson/', this.courseId]);

        } else {
          Swal.fire({
            type: "error",
            title: "Error",
            text: data.msg
          });
        }
      });

    }



  }
  dropActionQuestion(event: CdkDragDrop<string[]>) {

    //isPointerOverContainer is used to remove from dragbox

    moveItemInArray(this.ASRReq.nextActionStepQuestion, event.previousIndex, event.currentIndex);

  }
  dropPhysicalQuestion(event: CdkDragDrop<string[]>) {

    //isPointerOverContainer is used to remove from dragbox

    moveItemInArray(this.ASRReq.physicalQuestion, event.previousIndex, event.currentIndex);

  }
  dropNutritionalQuestion(event: CdkDragDrop<string[]>) {

    //isPointerOverContainer is used to remove from dragbox

    moveItemInArray(this.ASRReq.nutritionalQuestion, event.previousIndex, event.currentIndex);

  }

  dropIntrospectQuestion(event: CdkDragDrop<string[]>) {

    //isPointerOverContainer is used to remove from dragbox

    moveItemInArray(this.ASRReq.introspectQuestion, event.previousIndex, event.currentIndex);

  }



  questionType(value) {
    this.ASRQuestionType = value;

  }
  selectQuestionType(event) {

    if (this.ASRQuestionType == "PHYSICAL") {
      this.question_select_ph = false;
    } else if (this.ASRQuestionType == "INTROSPECT") {
      this.question_select_in = false;
    } else if (this.ASRQuestionType == "NEXTACTION") {
      this.question_select_next = false;
    } else if (this.ASRQuestionType == "NUTRITIONAL") {
      this.question_select_nu = false;
    }
  }


  AddQuestion() {

    this.question_type = this.AsrForm.value.questionType;
    this.optionListtemp = [];
    if (this.AsrForm.value.questionType == "days") {
      this.user_question_type = "Days"
      this.show_days = true;
      this.show_slider = false;
      this.show_optionsButton = false;
      this.show_text = false;
      this.show_optionsSlider = false;
    }
    if (this.AsrForm.value.questionType == "slider") {
      this.user_question_type = "Slider"
      this.show_days = false;
      this.show_slider = true;
      this.show_optionsButton = false;
      this.show_optionsSlider = false;
      this.show_text = false;
    }
    if (this.AsrForm.value.questionType == "optionsButton" || this.AsrForm.value.questionType == "optionsCheckBox" || this.AsrForm.value.questionType == "textDropdown" || this.AsrForm.value.questionType == "multiOptionsCheckBox") {

      if (this.AsrForm.value.questionType == "optionsButton") {
        this.user_question_type = "Option Button";
      }
      if (this.AsrForm.value.questionType == "optionsCheckBox") {
        this.user_question_type = "Option Checkbox";
      }
      if (this.AsrForm.value.questionType == "textDropdown") {
        this.user_question_type = "Text DropDown";
      }
      if (this.AsrForm.value.questionType == "multiOptionsCheckBox") {
        this.user_question_type = "Multi Options CheckBox";
      }
      this.show_days = false;
      this.show_slider = false;
      this.show_optionsButton = true;
      this.show_optionsSlider = false;
      this.show_text = false;
    }
    if (this.AsrForm.value.questionType == "optionsSlider") {
      this.user_question_type = "Option Slider";
      this.show_days = false;
      this.show_slider = false;
      this.show_optionsSlider = true;
      this.show_optionsButton = false;
      this.show_text = false;

    }
    if (this.AsrForm.value.questionType == "text") {
      this.user_question_type = "text";
      this.show_days = false;
      this.show_slider = false;
      this.show_optionsSlider = false;
      this.show_optionsButton = false;
      this.show_text = true;
    }


  }


  dropAdditional(event: CdkDragDrop<string[]>) {


    let tempValue = this.optionList[event.currentIndex];
    this.optionForm.controls['label'].setValue(tempValue.label);
    this.optionForm.controls['value'].setValue(tempValue.value);
    this.optionForm.controls['evaluationData'].setValue(tempValue.evaluationData);

    //isPointerOverContainer is used to remove from dragbox
    if (event.isPointerOverContainer == false) {
      this.optionList.splice(event.currentIndex, 1);
    }
    moveItemInArray(this.optionList, event.previousIndex, event.currentIndex);

  }
  AddOption() {
    let evaluationData = "NA";
    if (this.optionForm.value.evaluationData == null || this.optionForm.value.evaluationData == "") {
      evaluationData = "NA"
    } else {
      evaluationData = this.optionForm.value.evaluationData;
    }
    this.optionListtemp.push({ label: this.optionForm.value.label, value: this.optionForm.value.value, evaluationData: evaluationData });
    this.optionList = this.optionListtemp;
    if (this.optionList.length > 0) {
      this.showOptionError = false;
      this.optionForm.controls['value'].setValue(" ");
      this.optionForm.controls['evaluationData'].setValue("NA");
      this.optionForm.controls['label'].setValue(" ");
    }

  }

  updateUserStatusModal(row, content, btn) {

    if(this.ASRQuestionType == 'NEXTACTION') {
      this.isNewAction=true;
      this.optionForm.controls['iconName'].setValue("introspect");
    }
    if (row == "questionType") {

    } else {
      this.AsrForm.controls['questionType'].setValue(row.type);
      this.editQuestion(row);
    }

    // this.editQuestionIndex = index;
    this.AddQuestion();


    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
    // this.userDetails = row;
    this.statusFormSubmitted = false;
    // this.prepareUpdateStatusForm();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
  onAudioFileChanged(event) {
    const file = event.target.files[0];
    const allowedTypes = ['audio/mpeg', 'audio/wav', 'audio/x-m4a', 'audio/mp3', 'audio/x-wav'];
    if (file && !allowedTypes.includes(file.type) && !file.name.endsWith('.mp3') && !file.name.endsWith('.wav') && !file.name.endsWith('.m4a')) {
      Swal.fire("Error", "Please select a valid audio file (MP3, WAV, or M4A)", "error");
      return;
    }
    if (file) {
      this.spinner.show();
      this.CourseManagementService.uploadAudio(file).subscribe(data => {
        if (data["message"] === "Success") {
          Swal.fire("Success", "Audio uploaded successfully!", "success");
          this.AsrForm.controls['observeAudioUrl'].setValue(data.data.fileUrl);
          this.spinner.hide();
        } else {
          this.spinner.hide();
          Swal.fire({
            type: "error",
            title: "Error",
            text: data.msg
          });
        }
      }, error => {
        this.spinner.hide();
        Swal.fire({
          type: "error",
          title: "Error",
          text: "Something went wrong while uploading audio"
        });
      });
    }
  }

  cancel() {
    this.router.navigate(['main/course-management/view-lesson/', this.courseId]);
  }

}
